var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 29.3346H20.0001C26.6667 29.3346 29.3334 26.668 29.3334 20.0013V12.0013C29.3334 5.33464 26.6667 2.66797 20.0001 2.66797H12.0001C5.33341 2.66797 2.66675 5.33464 2.66675 12.0013V20.0013C2.66675 26.668 5.33341 29.3346 12.0001 29.3346Z",
    stroke: "#007BFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 13.3333C13.4727 13.3333 14.6666 12.1394 14.6666 10.6667C14.6666 9.19391 13.4727 8 11.9999 8C10.5272 8 9.33325 9.19391 9.33325 10.6667C9.33325 12.1394 10.5272 13.3333 11.9999 13.3333Z",
    stroke: "#007BFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.56006 25.2661L10.1334 20.8528C11.1867 20.1461 12.7067 20.2261 13.6534 21.0394L14.0934 21.4261C15.1334 22.3194 16.8134 22.3194 17.8534 21.4261L23.4001 16.6661C24.4401 15.7728 26.1201 15.7728 27.1601 16.6661L29.3334 18.5328",
    stroke: "#007BFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.e0476fb8164a55488b5559a6f4fc24fa.svg";
export { ForwardRef as ReactComponent };